import {Buffer} from 'buffer';

export const parseJwt = token => {
	return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString());
};
